import $ from 'jquery';

$(function () {
  const tables = [...document.querySelectorAll('.specification-image')];

  let observer;

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        setTimeout(function () {
          entry.target.classList.add('specification-image--visible');
        }, 600);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  tables.forEach((table) => {
    observer.observe(table);
  });
});
